export interface Checkpoint {
    id: number;
    name: string;
    order: number;
    type: "SpaceStation" | "Planet";
}

export class Checkpoints {
    public static readonly None: Checkpoint = { id: 0, name: "None", order: 0, type: "SpaceStation" };
    public static readonly Onboarding: Checkpoint = { id: 1, name: "Onboarding", order: 1, type: "SpaceStation" };
    public static readonly Landing: Checkpoint = { id: 2, name: "Landing", order: 2, type: "Planet" };
    public static readonly Exploring: Checkpoint = { id: 3, name: "Exploring", order: 3, type: "Planet" };
    public static readonly Video: Checkpoint = { id: 4, name: "Video", order: 4, type: "Planet" };
    public static readonly PreGame: Checkpoint = { id: 5, name: "PreGame", order: 5, type: "Planet" };
    public static readonly Game: Checkpoint = { id: 6, name: "Game", order: 6, type: "Planet" };
    public static readonly PostGame: Checkpoint = { id: 7, name: "PostGame", order: 7, type: "Planet" };
    public static readonly Activity: Checkpoint = { id: 8, name: "Activity", order: 8, type: "Planet" };
    public static readonly Badge: Checkpoint = { id: 9, name: "Badge", order: 9, type: "Planet" };
    public static readonly PlanetClose: Checkpoint = { id: 10, name: "PlanetClose", order: 10, type: "Planet" };
    public static readonly Leaving: Checkpoint = { id: 11, name: "Leaving", order: 11, type: "Planet" };
    public static readonly BetweenPlanets: Checkpoint = { id: 12, name: "BetweenPlanets", order: 12, type: "SpaceStation" };
    public static readonly GalaxyCeremony: Checkpoint = { id: 13, name: "GalaxyCeremony", order: 13, type: "SpaceStation" };
    public static readonly GalaxyComplete: Checkpoint = { id: 14, name: "GalaxyComplete", order: 14, type: "SpaceStation" };

    public static All: Checkpoint[] = [
        Checkpoints.None,
        Checkpoints.Onboarding,
        Checkpoints.Landing,
        Checkpoints.Exploring,
        Checkpoints.Video,
        Checkpoints.PreGame,
        Checkpoints.Game,
        Checkpoints.PostGame,
        Checkpoints.Activity,
        Checkpoints.Badge,
        Checkpoints.PlanetClose,
        Checkpoints.Leaving,
        Checkpoints.BetweenPlanets,
        Checkpoints.GalaxyCeremony,
        Checkpoints.GalaxyComplete,
    ];

    public static FindById(id: number) {
        return this.All.find(x => x.id === id) || this.None;
    }

    public static GetNext(checkpoint: Checkpoint) {
        let order = checkpoint.order + 1;
        return this.All.find(x => x.order === order) || this.None;
    }

    public static GetPrevious(checkpoint: Checkpoint) {
        let order = checkpoint.order - 1;
        return this.All.find(x => x.order === order) || this.None;
    }
}



// WEBPACK FOOTER //
// ./src/constants/Checkpoints.ts